function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}
import { actions as formActions } from 'react-redux-form';
import { actions } from "../../BasicReducer";
import EntitiesAPI from "../../Entities/EntitiesAPI";

import { notificationActions } from "../../Notifications";
import { RequestParams } from "../../utils/RequestParams";
import { t } from "../../I18N";
import { getThesaurusPropertyNames } from "../../../shared/commonTopicClassification";


import { updateEntities } from "./libraryActions";

function toggleQuickLabelAutoSave() {
  return (dispatch, getState) => {
    const opts = getState().library.sidepanel.quickLabelState.toJS();
    dispatch(
      actions.set('library.sidepanel.quickLabelState', _objectSpread(_objectSpread({},
      opts), {}, {
        autoSave: !opts.autoSave })
      )
    );
  };
}

function buildQuickLabelMetadata(docs, propNames) {
  const counts = propNames.reduce(
    (res, p) => _objectSpread(_objectSpread({}, res), {}, { [p]: {} }),
    {}
  );
  docs.forEach((d) =>
  propNames.forEach((p) => {
    if (!d.metadata || !d.metadata[p]) {
      return;
    }
    if (!counts[p]) {
      counts[p] = {};
    }
    d.metadata[p].forEach((mo) => {
      if (!mo.value) {
        return;
      }
      if (!counts[p][mo.value]) {
        counts[p][mo.value] = 1;
      } else {
        counts[p][mo.value] += 1;
      }
    });
  })
  );
  return propNames.reduce(
    (res, p) => _objectSpread(_objectSpread({},
    res), {}, {
      [p]: {
        added: [],
        removed: [],
        originalFull: Object.keys(counts[p]).filter((k) => counts[p][k] === docs.length),
        originalPartial: Object.keys(counts[p]).filter((k) => counts[p][k] < docs.length)
      } }),

    {}
  );
}

function selectedDocumentsChanged() {
  return (dispatch, getState) => {var _state$library, _state$library$sidepa, _state$library$sidepa2;
    const model = 'library.sidepanel.quickLabelMetadata';
    const state = getState();
    if (!((_state$library = state.library) !== null && _state$library !== void 0 && (_state$library$sidepa = _state$library.sidepanel) !== null && _state$library$sidepa !== void 0 && (_state$library$sidepa2 = _state$library$sidepa.quickLabelState) !== null && _state$library$sidepa2 !== void 0 && _state$library$sidepa2.get('thesaurus'))) {
      return;
    }
    dispatch(formActions.reset(model));
    const sharedIds = state.library.ui.
    get('selectedDocuments').
    map((d) => d.get('sharedId')).
    toJS();
    const docs = state.library.documents.
    get('rows').
    filter((d) => sharedIds.includes(d.get('sharedId'))).
    toJS();
    if (!docs.length) {
      return;
    }
    const templateIds = docs.map((d) => d.template).filter((v) => v);
    const templates = state.templates.
    filter((template) => templateIds.includes(template.get('_id'))).
    toJS();
    const propNames = getThesaurusPropertyNames(
      state.library.sidepanel.quickLabelState.get('thesaurus'),
      templates
    );
    const newState = buildQuickLabelMetadata(docs, propNames);
    dispatch(formActions.load(model, newState));
    dispatch(formActions.setPristine(model));
  };
}

function maybeSaveQuickLabels(force) {
  return async (dispatch, getState) => {var _state$library2, _state$library2$sidep, _state$library2$sidep2;
    const state = getState();
    if (!force && !((_state$library2 = state.library) !== null && _state$library2 !== void 0 && (_state$library2$sidep = _state$library2.sidepanel) !== null && _state$library2$sidep !== void 0 && (_state$library2$sidep2 = _state$library2$sidep.quickLabelState) !== null && _state$library2$sidep2 !== void 0 && _state$library2$sidep2.get('autoSave'))) {
      return;
    }
    const current = state.library.sidepanel.quickLabelMetadata;
    const diffs =

    {};
    Object.keys(current).forEach((p) => {
      if (current[p] && current[p].added.length + current[p].removed.length > 0) {
        diffs[p] = {
          added: current[p].added.map((v) => ({ value: v })),
          removed: current[p].removed.map((v) => ({ value: v }))
        };
      }
    });
    if (!diffs || !Object.keys(diffs).length) {
      return;
    }
    const ids = state.library.ui.
    get('selectedDocuments').
    map((entity) => entity.get('sharedId')).
    toJS();
    const updatedDocs = await EntitiesAPI.multipleUpdate(
      new RequestParams({ ids, values: { diffMetadata: diffs } })
    );
    dispatch(notificationActions.notify(t('System', 'Update success', null, false), 'success'));
    dispatch(updateEntities(updatedDocs));
    dispatch(selectedDocumentsChanged());
  };
}

export { selectedDocumentsChanged, maybeSaveQuickLabels, toggleQuickLabelAutoSave };